import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardContent,
  Grid,
} from '@mui/material';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import { RichTreeView } from '@mui/x-tree-view';
import { jsonToTree } from '../../utils/json-to-tree';
import InfoTooltipIcon from '@/components/icons/InfoTooltipIcon';
import GatewayLoadingIndicator from '@/components/indicators/GatewayLoadingIndicator';

const PortfolioAnalysisManagementDrawer = ({
  open,
  onClose,
  account,
  subscription,
  isFetching,
}) => {
  return (
    <>
      <GatewayLoadingIndicator isLoading={isFetching} />
      <Drawer
        anchor="right"
        open={open && !isFetching}
        onClose={onClose}
        PaperProps={{
          sx: { width: '40%', height: '100%' },
        }}
      >
        <Box p={2}>
          <Typography variant="h6" gutterBottom>
            Account Details
          </Typography>
          {account ? (
            <>
              <Grid container spacing={2}>
                <Grid item lg={12}>
                  <Card variant="outlined">
                    <CardContent>
                      <HeaderDisplay label={'Account'} />
                      <MultiValueDisplay label={'Name'} value={account.Name} />
                      <MultiValueDisplay
                        label={'Id'}
                        value={account.AccountId}
                      />
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item lg={12}>
                  <Card variant="outlined">
                    <CardContent>
                      <HeaderDisplay label={'Subscription'} />
                      <MultiValueDisplay
                        label={'# Power meters'}
                        value={subscription?.num_power_meters ?? 0}
                      />{' '}
                      <MultiValueDisplay
                        label={'# Heat meters'}
                        value={subscription?.num_heat_meters ?? 0}
                      />{' '}
                      <MultiValueDisplay
                        label={'# Water meters'}
                        value={subscription?.num_water_meters ?? 0}
                      />
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item lg={12}>
                  <Card variant="outlined">
                    <CardContent>
                      <HeaderDisplay label={'Portefølje API outputs'} />
                      {account.jsonObjects.map((o, index) => {
                        return (
                          <Accordion key={index}>
                            <AccordionSummary>
                              <Typography>{o.name}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <RichTreeView
                                items={jsonToTree(o.object, o.idKey, o.nameKey)}
                              />
                            </AccordionDetails>
                          </Accordion>
                        );
                      })}
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>{' '}
            </>
          ) : (
            <Typography variant="body1">No account data available.</Typography>
          )}
        </Box>
      </Drawer>
    </>
  );
};

export default PortfolioAnalysisManagementDrawer;

const HeaderDisplay = ({ label, description }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        mb: 2,
      }}
    >
      <Typography variant="body1" color="textSecondary" fontWeight="bold">
        {label}
      </Typography>
      {description && <InfoTooltipIcon title={description} />}
    </Box>
  );
};

const MultiValueDisplay = ({ label, value }) => {
  return (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="h6" color="textPrimary">
        {value}
      </Typography>
    </Box>
  );
};
